import { timetableBeta } from "@/api";
import { useEffect, useState } from "react";

const isPermanentBbbLink = (link) => {
    try {
        const path = new URL(link, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase();
        return path === '/v1/integration-configs/join-big-blue-button-permanent-link'
            || path === '/integration-configs/join-big-blue-button-permanent-link';
    } catch {
        return false;
    }
};

export const useGetPreparedMeetingLink = ({linkToMeeting, childrenId, reportId, role}) => {
    const [result, setResult] = useState(null);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if(!linkToMeeting) return;
        let active = true;
        const finish = (link) => {
            if(active) setResult({linkToMeeting, childrenId, reportId, role, attempt, link});
        };

        timetableBeta.prepareLinkToMeeting({
            userId: childrenId,
            link: linkToMeeting,
            reportId
        })
            .then(({data}) => {
                finish(data?.status === 'success' && data?.link ? data.link : '');
            })
            .catch(() => finish(''));

        return () => { active = false; };
    }, [childrenId, linkToMeeting, reportId, role, attempt])

    // Never reuse another lesson's/user's link, including the render before the effect runs.
    const isCurrentResult = result?.linkToMeeting === linkToMeeting
        && result?.childrenId === childrenId && result?.reportId === reportId
        && result?.role === role && result?.attempt === attempt;
    const preparedMeetingLink = isCurrentResult ? result.link : '';
    const loadingPreparedMeetingLink = !!linkToMeeting && !isCurrentResult;
    const requiresPreparation = isPermanentBbbLink(linkToMeeting);
    const meetingLink = preparedMeetingLink || (requiresPreparation ? '' : linkToMeeting);
    const meetingLinkError = requiresPreparation && isCurrentResult && !preparedMeetingLink;

    return {
        preparedMeetingLink, loadingPreparedMeetingLink, meetingLink, meetingLinkError,
        retryPreparedMeetingLink: () => setAttempt(value => value + 1),
    }
}
